/**
 * Geração de ids. Sem dependência externa e sem depender de `crypto` — este pacote
 * roda no navegador, no servidor e no worker.
 */
const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
function randomPart(length) {
    let out = '';
    const g = globalThis;
    const cryptoObj = g.crypto;
    if (cryptoObj?.getRandomValues) {
        const bytes = new Uint8Array(length);
        cryptoObj.getRandomValues(bytes);
        for (let i = 0; i < length; i++)
            out += ALPHABET[bytes[i] % ALPHABET.length];
        return out;
    }
    for (let i = 0; i < length; i++) {
        out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
    }
    return out;
}
export function createId(prefix) {
    return `${prefix}_${Date.now().toString(36)}${randomPart(8)}`;
}
//# sourceMappingURL=ids.js.map